import React from "react";
import Aux from "../utils/AuxFunctions";
import "./Account.css"
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Colors from "../utils/Colors";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import LoadingHelper from "../utils/Utilities/LoadingHelper";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            CurrentPassword: "",
            NewPassword: "",
            ConfirmPassword: "",
            isLoading: false,
            error: "",
            sucess: false,
        }
    }

    onSubmitNewPassword = async () => {
        if (this.state.isLoading || this.state.sucess)
            return;
        if (this.state.CurrentPassword === "" || this.state.ConfirmPassword === "" || this.state.NewPassword === "") {
            this.setState({ error: "You must fill all fields", isLoading: false })
            return;
        }
      
        if (this.state.CurrentPassword === this.state.NewPassword) {
            this.setState({ error: "You can't use the previous password", isLoading: false })
            return;
        }
        if (this.state.NewPassword !== this.state.ConfirmPassword) {
            this.setState({ error: "Passwords dont match", isLoading: false })
            return;
        }
        try {
            this.setState({ isloading: true })
            const auth = await Fire.shared.reauthenticate(this.state.CurrentPassword)
            if (auth.code === "auth/wrong-password") {
                this.setState({ error: "Your password its incorrect" })
            } else if (auth.user !== null) {
                const status = await Fire.shared.changePassword(this.state.NewPassword)
                if (status.code === "auth/weak-password") {
                    this.setState({ error: "Weak password, at least 6 characters" })
                } else if (status === "sucess") {
                    this.setState({sucess:true, NewPassword: "", ConfirmPassword: "", CurrentPassword: "" })
                } else {
                    this.setState({ error: "Try a new password" })
                }
            }
            this.setState({ isLoading: false })
        } catch (error) {
            switch (error.code) {
                case 'auth/wrong-password':
                    this.setState({ error: "Wrong password" })
                    break;
                case 'auth/invalid-email':
                    this.setState({ error: "Invalid email adress" })
                    break;
                default:
                    break;
            }
            Aux.handleError(error)
            this.setState({ isLoading: false })
        }
    }

    goBack = () => {
        try{
            this.props.history.goBack()
        }catch(error){
            Aux.handleError(error)
        }
    }

    render() {

        return (
            <div style={{width:"100%"}}>
            
            <section className="container ">
                <div className="reversed-button-hover" style={{display:"flex", alignItems:"center"}} onClick={this.goBack}>
                        <ChevronLeftIcon style={{marginRight:5}}></ChevronLeftIcon>
                        <h2>Change Password</h2>
                </div>
                {/* <span>Did you forgot your password?  </span> */}
                {this.props.myDataProvider.user ? 
                this.props.myDataProvider.user.provider !== "email" ? (
                    <div style={{ display: "flex", alignItems: "center", justifyContent:"center" }}>
                        <span style={{ marginTop: 30 }}>
                            you logged in with social media
                        </span>
                    </div>
                ) : (
                        <div>
                            <div style={{margin:"20px 0"}}>
                                <span style={{ color: "#777", alignSelf: "center", fontSize: 14, }}>
                                    To change your password please fill out the fields below
                                </span>
                            </div>
                            <SucessMessage isSucess={this.state.sucess}></SucessMessage>
                            <ErrorMessage text={this.state.error}></ErrorMessage>
                            <TextInputMaterial type="password"  placeholder="Current Password" title="Current Password"
                                value={this.state.CurrentPassword} style={{marginTop:15}}
                                onChange={(e) => {
                                    this.setState({ CurrentPassword: e.target.value, error: "" });
                                }}
                            />

                            <TextInputMaterial type="password" placeholder="New Password" title="New Password"
                                value={this.state.NewPassword} style={{marginTop:15}}
                                onChange={(e) => {
                                    this.setState({ NewPassword: e.target.value, error: "" });
                                }}
                            />
                            <TextInputMaterial type="password" placeholder="Confirm Password" title="Confirm Password"
                                value={this.state.ConfirmPassword} style={{marginTop:15}}
                                onChange={(e) => {
                                    this.setState({ ConfirmPassword: e.target.value, error: "" });
                                }}
                            />
                            
                            <ButtonLoader
                                text="Change Password"
                                loading={this.state.isLoading}
                                style={{ backgroundColor: Colors.mainColor, width: "100%", height:45, marginTop:25 }}
                                // icon={FacebookIcon}
                                onClick={this.onSubmitNewPassword}
                            ></ButtonLoader>

                        </div>
                    ) : 
                        <LoadingHelper/>
                    }

            </section>
            </div>
        );
    }
}

export default withMyDataContext(ForgotPassword);